/**
 * This function is used for local filtering of what we assume to be complete in-memory options lists.
 * It assumes a user preference for exact value matches, then startsWith value matches, then contains label matches;
 * shown in that order of precedence (unless skipLabelFilter). IF USING THIS FUNCTION, ensure this behavior is desired.
 * As of November 2017 all usages of this function (countries and protocols) have been validated.
 *
 * @param options
 * @param filter
 */
export function localOptionFilter(options, filter) {
  const parsedFilter = Array.isArray(filter) ? filter.length && filter[0] : filter;
  const lowerFilter = (parsedFilter || '').toLowerCase();
  try {
    let valueMatches = options.filter(({ value }) => (value || '').toString().toLowerCase() === lowerFilter);
    valueMatches = valueMatches.concat(
      options.filter((option) => {
        const { value } = option;
        return !valueMatches.includes(option) && (value || '').toString().toLowerCase().startsWith(lowerFilter);
      })
    );
    return valueMatches.concat(
      options.filter((option) => {
        const { matcher, label } = option;
        const labelStr = typeof label === 'string' ? label.toLowerCase() : '';
        return (
          !valueMatches.includes(option) &&
          (matcher !== undefined ? matcher.toLowerCase() : labelStr).includes(lowerFilter)
        );
      })
    );
  } catch (e) {
    console.error('Error in localOptionFilter:', e);
    return [];
  }
}
